import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AppShell from './components/AppShell';
import Canonical from './components/Canonical';
import CompareSection from './components/CompareSection';
import MetaTiers from './components/MetaTiers';
import PokedexHome from './components/PokedexHome';
import AgentsPage from './components/AgentsPage';
import PokemonDetail from './components/PokemonDetails';

function App() {
  return (
    <Router>
      <Canonical />
      <AppShell>
        <Routes>
          <Route path="/" element={<PokedexHome />} />
          <Route path="/compare" element={<CompareSection />} />
          <Route path="/meta" element={<MetaTiers />} />
          <Route path="/pokemon/:id/agents" element={<AgentsPage />} />
          <Route path="/pokemon/:id" element={<PokemonDetail />} />
        </Routes>
      </AppShell>
    </Router>
  );
}

export default App;
